import React, {Fragment} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from "react-redux";

import {
    forgotPasswordToken
} from '../../vendors/actions/user';
import NewPassword from './newPassowrd';
import SendEmail from './sendEmail';
import {ClockLoader} from "react-spinners";
import {Container, Grid} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import MuiAlert from "@material-ui/lab/Alert/Alert";
import {Link} from "react-router-dom";
import {isMobileBrowser} from "../../vendors/utils/common";

interface OwnProps {
    forgotPasswordToken?: any,
    token?: any
}

interface MainState {
    user: any,
    apiError: boolean,
    view: string
}

interface ConnectStateProps {
    User: any,
    ForgotPasswordForms: any
}

interface ConnectDispatchProps {
    forgotPasswordToken?: (token: any) => void,
}


type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps;

const titles: {
    [key: string]: any
} = {
    "0": '',
    "1": <div className="MuiTypography-root text-white text-center section-title">
        <Typography className="main-title font-weight-bold">
            Recover Password
        </Typography>
        <Typography className="secondary-title font-weight-normal">
            Enter your email address and we will send you a link to reset your password.
        </Typography>
    </div>,
    "2": <div className="MuiTypography-root text-white text-center section-title">
        <Typography className="main-title font-weight-bold">
            New Password
        </Typography>
    </div>,
};

class ForgotPassword extends React.Component<HeaderProps, MainState> {
    state = {
        user: null,
        apiError: false,
        view: "0"
    };
    private views: {
        [key: string]: any
    } = {
        "0": <div
            className="d-flex align-items-center justify-content-center clock--loader">
            <ClockLoader color={'var(--primary)'} loading={true}/>
        </div>,
        "1": <SendEmail/>,
        "2": <NewPassword token={this.props.token}/>,
        "3": <div>
            <MuiAlert className="mb-4" severity="warning">
                <div className="d-flex align-items-center align-content-center">
                          <span>
                          <strong className="d-block">The link you tried to use no longer active.</strong>
                             Please click the Forget Password button to reset your password.
                          </span>
                </div>
            </MuiAlert>
            <div className={'text-left mt-4'}>
                <Link  to={'/forgot-password/null'} onClick={() => this.resetView()}>
                    Forgot Password?
                </Link>
            </div>
        </div>,
    };

    resetView() {
        this.setState({view:"1"})
    }


    async componentDidMount() {
        const {token} = this.props;

        if (!token || token === 'null') {
            this.setState({view: "1"})
        } else {
            const res = await this.props.forgotPasswordToken(token);

            if (res.payload && res.payload?.code !== 400) {
                this.setState({view: "2"})
            } else {
                this.setState({view: "3"})
            }
        }
    }


    render() {
        const {view} = this.state;

        return (
            <Fragment>
                <div className={`w-100 min-vh-100 forgot-password-page`}>
                    <Grid item
                          xs={12}
                          md={5}
                          lg={6}
                          container
                          spacing={0}
                          justify={'center'}
                          direction={'column'}
                          className="w-100 min-vh-100 m-auto">
                        <Container maxWidth="lg">
                            <div className={'left-section-logo-white'}/>
                            {titles[view] && titles[view]}
                            <div className='main-box'>
                                {this.views[view]}
                            </div>
                        </Container>
                    </Grid>
                </div>
            </Fragment>
        )
    }
}

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {User, ForgotPasswordForms} = state;
    return {
        User,
        ForgotPasswordForms
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        forgotPasswordToken: (token: any) => dispatch(forgotPasswordToken(token))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
